module.exports = __webpack_public_path__ + "static/bayequity_circle_mark-31e80b7a8d3b5ed1f05e3a6920f71529.png";